import axios from 'axios';
// @ts-ignore
import { APIRoute, EP } from '@/src/endpoints';

export interface SessionStatusResponse {
  // HTTP status, 401 when the session has timed out
  status: number;
  secondsRemaining: number;
}

// Not be-api-client: a 401 is an expected answer here, be-api-client would show the logged out dialog for it.
// X-Requested-With makes devise respond with a 401 instead of redirecting to the login page.
const sessionApiClient = axios.create({
  baseURL: '/api/v1',
  headers: { 'X-Requested-With': 'XMLHttpRequest' },
  validateStatus: () => true,
});

async function get(endpoint: string): Promise<SessionStatusResponse> {
  const response = await sessionApiClient.get(APIRoute(endpoint));
  return {
    status: response.status,
    secondsRemaining: Number(response.data?.seconds_remaining) || 0,
  };
}

// Time left before the session times out, does not keep the session alive
export function fetchSessionStatus(): Promise<SessionStatusResponse> {
  return get(EP.current_user.session_status);
}

// Keeps the session alive, returns the time left afterwards
export function extendSession(): Promise<SessionStatusResponse> {
  return get(EP.current_user.heartbeat);
}
